import { useSearchParams } from "next/navigation"
import React from "react"

import { IDVerificationStatus } from "@lib/clients/nelo-api-client"
import { medusaClient } from "@lib/config"
import { neloApiClient } from "@lib/config-client"

import LoanOptions from "../../components/loan-options"
import { useSession } from "../session-context"
import { StepProps } from "../step-registry"

const LoanOptionsStep: React.FC<StepProps> = ({ onComplete }) => {
  const { sessionData, updateProgress, updateProduct } = useSession()
  const searchParams = useSearchParams()
  const variantId = searchParams.get("variantId")

  const handleOrderComplete = async (cartId: string) => {
    const idvStatusResponse = await neloApiClient.checkIdentityVerificationStatus()

    if (idvStatusResponse.verificationStatus === IDVerificationStatus.VERIFIED) {
      await medusaClient.carts.complete(cartId)
    }

    updateProgress({ orderPlaced: true })

    onComplete()
  }

  const handleServerError = () => {
    updateProgress({ serverErrorOccurred: true })
    onComplete()
  }

  const handleCartTotalChange = (total: number) => {
    updateProduct({ cartTotal: total })
  }

  return (
    <LoanOptions
      variantId={variantId}
      onComplete={handleOrderComplete}
      onServerError={handleServerError}
      onCartTotalChange={handleCartTotalChange}
      preSelectedInstallment={sessionData.product.preSelectedInstallment}
    />
  )
}

export default LoanOptionsStep
